import { Button, DialogContent } from '@mui/material';
import { ReactElement, ReactNode, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '..';

type Reason = 'backdropClick' | 'escapeKeyDown' | 'cancelClick' | 'successClick';
type OnCloseFunc<E extends SyntheticEvent = SyntheticEvent> = (event: E | null, reason: Reason) => void;

export interface ConfirmationDialogProps {
  title: string;
  message: string | ReactNode;
  confirmActionLabel?: string;
  confirmAction: () => void;
  open: boolean;
  onClose: OnCloseFunc;
  actionIsDestructive?: boolean;
}

export function ConfirmationDialog({
  title,
  message,
  confirmActionLabel = 'SHARED_CONFIRM',
  confirmAction,
  open,
  onClose,
  actionIsDestructive,
}: Readonly<ConfirmationDialogProps>): ReactElement<ConfirmationDialogProps> {
  const [t] = useTranslation();

  const handleConfirm = (): void => {
    confirmAction();
    onClose(null, 'successClick');
  };
  return (
    <Dialog
      title={title}
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button role="button" variant="outlined" onClick={() => onClose(null, 'cancelClick')}>
            {t('SHARED_CANCEL')}
          </Button>
          <Button role="button" className="bg-error-500/75" onClick={handleConfirm}>
            {t(confirmActionLabel as unknown as TemplateStringsArray)}
          </Button>
        </>
      }
    >
      <DialogContent>{message}</DialogContent>
    </Dialog>
  );
}
